/**
 * ticketflow/appConfig — câblage SPÉCIFIQUE TicketFlow (hors modules génériques).
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * C'est ICI (et pas dans engine/ ui/) que vivent les détails propres à TicketFlow :
 * la lecture de l'env CRA `REACT_APP_*`, l'URL du serveur, la clé de jeton. Les
 * modules (`@mostajs/app-admin` / `-ui-react` / `auth-ui`) restent neutres — l'app
 * hôte leur INJECTE cette config. Une app Vite lirait `import.meta.env`, une app
 * Next son propre mécanisme : seule cette couche change.
 */
export const TICKETFLOW_API_CONFIG = {
  baseUrl: (process.env.REACT_APP_API_BASE || 'http://localhost:5000'),
  // paths: {}  // protocole app-admin standard (surcharge possible ici)
};

export const TICKETFLOW_TOKEN_KEY = 'tf-admin-token';

/**
 * Mode de déploiement de la console :
 *  - 'local'   : app Windows/LAN → sélecteur de serveurs local (ServerPicker) ;
 *  - 'central' : console hébergée (ticket-admin.amia.fr) → baseUrl = relais de
 *                site injecté, PAS de gestion de serveurs LAN (masque le picker).
 */
export const TICKETFLOW_ADMIN_MODE = process.env.REACT_APP_ADMIN_MODE || 'local';

/** Libellé du site géré (mode central), à titre indicatif dans le login. */
export const TICKETFLOW_SITE_LABEL = process.env.REACT_APP_CENTRAL_SITE || '';
